import React, { useEffect, useState } from "react";
import { useAuth } from "../../contexts/AuthContextProvider.jsx";
import { showErrorToast, showPromiseToast } from "../../services/toastService.js";
import { LEVEL_MAP } from "../../utils/usersUtil.js";
import {
	changePassword,
	getActiveSessions,
	logoutAll,
	updateUser,
} from "../../services/authService.js";
import ConfirmModal from "./ConfirmModal.jsx";

export default function ProfileModal({ close }) {
	const { user } = useAuth();
	const [currentPassword, setCurrentPassword] = useState("");
	const [newPassword, setNewPassword] = useState("");
	const [confirmNewPassword, setConfirmNewPassword] = useState("");
	const [sessions, setSessions] = useState(0);
	const [showConfirmModal, setShowConfirmModal] = useState(false);
	const [newEmail, setNewEmail] = useState(user.email);

	useEffect(() => {
		getActiveSessions().then((result) => setSessions(result.data.activeSessions));
	}, []);

	const handleSubmit = async (e) => {
		e.preventDefault();
		if (newPassword !== confirmNewPassword) {
			showErrorToast("Le nuove password non corrispondono!");
			return;
		}

		showPromiseToast(changePassword(currentPassword, newPassword), {
			pending: "Richiesta in corso...",
			success: "Password modificata con successo",
		}).then(close);
	};

	const handleDisconnectAll = () => {
		showPromiseToast(logoutAll(), {
			pending: "Richiesta in corso...",
			success: "Utente disconnesso con successo",
		})
			.then(() => setSessions(0))
			.finally(() => setShowConfirmModal(false));
	};

	const handleEmailChange = () => {
		showPromiseToast(updateUser(newEmail), {
			pending: "Richiesta in corso...",
			success: "Email modificata con successo",
		}).then(close);
	};

	return (
		<div className="fixed inset-0 bg-gray-800 bg-opacity-50 flex items-center justify-center z-50">
			<div className="bg-white rounded-lg p-6 w-[800px] shadow-lg">
				<h2 className="text-2xl font-bold mb-4">Gestione Profilo Utente</h2>
				<p className="mb-1 text-blue-500 text-xl font-bold">{user.username}</p>
				<p className="mb-1 text-blue-900 text-md">{user.email}</p>
				<p className="mb-5 text-blue-900 text-md">
					{LEVEL_MAP[user.level]} - {user.office || <i>nessun ente</i>}
				</p>
				<p className="mb-5 text-blue-900 text-md">
					<span>
						Sessioni <i>ricordami</i>: {sessions}
					</span>
					<span
						className="ml-2 text-red-500 underline cursor-pointer"
						onClick={() => setShowConfirmModal(true)}
					>
						(disconnetti tutte)
					</span>
				</p>
				<div className="grid grid-cols-1 md:grid-cols-2 gap-4">
					<div>
						<div className="mb-4">
							<label htmlFor="newEmail" className="block text-sm font-medium">
								Nuova Email
							</label>
							<input
								id="newEmail"
								type="email"
								className="w-full p-2 border rounded mt-1"
								value={newEmail}
								onChange={(e) => setNewEmail(e.target.value)}
								required
							/>
						</div>
						<div className="flex justify-end">
							<button
								id="changeEmail"
								aria-label="Modifica Email"
								onClick={handleEmailChange}
								type="submit"
								className="px-4 py-2 bg-blue-600 text-white rounded hover:bg-blue-700"
							>
								Modifica Email
							</button>
						</div>
					</div>

					<div>
						<form onSubmit={handleSubmit}>
							<div className="mb-4">
								<label
									htmlFor="currentPassword"
									className="block text-sm font-medium"
								>
									Password attuale
								</label>
								<input
									id="currentPassword"
									type="password"
									className="w-full p-2 border rounded mt-1"
									value={currentPassword}
									onChange={(e) => setCurrentPassword(e.target.value)}
									required
								/>
							</div>
							<div className="mb-4">
								<label htmlFor="newPassword" className="block text-sm font-medium">
									Nuova password
								</label>
								<input
									id="newPassword"
									type="password"
									className="w-full p-2 border rounded mt-1"
									value={newPassword}
									onChange={(e) => setNewPassword(e.target.value)}
									required
								/>
							</div>
							<div className="mb-4">
								<label
									htmlFor="confirmNewPassword"
									className="block text-sm font-medium"
								>
									Conferma nuova password
								</label>
								<input
									id="confirmNewPassword"
									type="password"
									className="w-full p-2 border rounded mt-1"
									value={confirmNewPassword}
									onChange={(e) => setConfirmNewPassword(e.target.value)}
									required
								/>
							</div>
							<div className="flex justify-end">
								<button
									id="close"
									aria-label="Chiudi"
									className="mr-2 px-4 py-2 bg-gray-200 rounded hover:bg-gray-300"
									onClick={close}
								>
									Chiudi
								</button>
								<button
									id="changePassword"
									aria-label="Modifica Password"
									type="submit"
									className="px-4 py-2 bg-blue-600 text-white rounded hover:bg-blue-700"
								>
									Modifica Password
								</button>
							</div>
						</form>
					</div>
				</div>
			</div>
			{showConfirmModal && (
				<ConfirmModal
					message="Sei sicuro di voler disconnettere tutte le sessioni attive?"
					onConfirm={handleDisconnectAll} // Azione di conferma
					onCancel={() => setShowConfirmModal(false)} // Chiudi il modale
				/>
			)}
		</div>
	);
}
